import { gql } from '__generated__';

export default gql(`
  query GetMailPermissions($id: ID!) {
    project(id: $id) {
      id
      mail_permissions {
        id
        title
        label
        interest_list_event {
          id
          title
        }
        events {
          id
          title
        }
        opt_in_count
        opt_out_count
        translations {
          ...TranslationFields
        }
      }
    }
  }
`);
